// Bank direction for one row of an imported file. Only bank data counts: the
// signed amount, or a debit/credit indicator column when the amount is
// unsigned. Words in the description or a "payment" label never decide it.
const DEBIT = /\b(debit|dr|withdrawal|withdrawl)\b/i;
const CREDIT = /\b(credit|cr|deposit)\b/i;

export function importRowDirection(rawAmount, indicator) {
  if (rawAmount === null || rawAmount === undefined || rawAmount === '') return null;
  const text = String(rawAmount).trim();
  if (text.startsWith('-')) return 'out';
  const label = String(indicator || '');
  if (DEBIT.test(label)) return 'out';
  if (CREDIT.test(label)) return 'in';
  return 'in';
}

// Type for the preview: transfer/refund labels are kept as hints (the server
// keeps Transfer only when the other side is found); otherwise income or
// expense follows the bank direction.
export function importRowType(label, direction) {
  const lower = String(label || '').toLowerCase();
  if (lower.includes('transfer')) return 'transfer';
  if (lower.includes('refund') || lower.includes('return')) return 'refund';
  if (direction === null) return null;
  return direction === 'in' ? 'income' : 'expense';
}
